<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="门店名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="联系人" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.username }}
				  </template>
				</el-table-column>
				<el-table-column label="电话" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.mobile }}
				  </template>
				</el-table-column>
				<el-table-column label="地址" min-width="200" align="center">
				  <template slot-scope="scope">
					{{ scope.row.address }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="体检套餐" placement="top">
					  <el-button type="warning" icon="el-icon-tickets" size="mini" circle @click="handlelist(scope.row.id)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
		    <el-form-item label="门店名称" prop="name">
		      <el-input v-model="form.name" placeholder="请输入门店名称" type="text" clearable />
		    </el-form-item>
		    <el-form-item label="联系人" prop="username">
		      <el-input v-model="form.username" placeholder="请输入管理人" type="text" clearable />
		    </el-form-item>
		    <el-form-item label="电话" prop="mobile">
		      <el-input v-model="form.mobile" placeholder="请输入电话" type="text" clearable />
		    </el-form-item>
			<el-form-item label="微信号" prop="wx_code">
			  <el-input v-model="form.wx_code" placeholder="请输入微信号" type="text" clearable />
			</el-form-item>
			<el-form-item label="区域" prop="area_id">
			  <el-cascader
				size="large"
				:options="options"
				v-model="selectedOptions"
				@change="handleChange">
			  </el-cascader>
			</el-form-item>
			<el-form-item label="经纬度" prop="coordinate">
			  <el-input v-model="form.coordinate" placeholder="请选择经纬度" size="medium" style="width: 350px;" @focus="mapVisible=true" />
			</el-form-item>
			<el-form-item label="地址" prop="address">
			  <el-input v-model="form.address" placeholder="请输入地址" type="text" clearable />
			</el-form-item>
			<el-form-item label="排序" prop="sort">
			  <el-input v-model="form.sort" placeholder="请输入排序" type="text" clearable />
			</el-form-item>
		   <el-form-item  label="状态">
		      <el-radio-group v-model="form.status">
		      	<el-radio :label="1">使用</el-radio>
		      	<el-radio :label="2">停用</el-radio>
		      </el-radio-group>
		    </el-form-item>
			<el-form-item label="头像" prop="avatar">
			  <el-upload
				class="upload-border"
				action="/manage/images/upload"
				:show-file-list="false"
				:on-success="uploadSuccess">
				<img v-if="form.avatar" :src="form.url" class="w-100 h-100">
				<i v-else class="el-icon-plus uploader-icon"></i>
			  </el-upload>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
		<tmap
		  v-if="mapVisible"
		  ref="MapWin"
		  :map-position="mapPosition"
		  @closeMapWin="mapVisible = false"
		  @setMap="setMap"
		/>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
	import tmap from '@/components/common/t_map.vue'
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
			tmap
		},
		data() {
			return {
				preUrl: 'store',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					name:'',
					username:'',
					wx_code:'',
					mobile:'',
					address:'',
					sort:100,
					status:1,
					avatar:'',
					url:'',
					area_id:'',
					province:"",
					city:"",
					country:"",
					coordinate:'',
				},
				rules:{
					username: [
					  { required: true, message: '请输入名称', trigger: 'blur' }
					],
					mobile: [
					  { required: true, message: '请输入电话', trigger: 'blur' }
					],
					name: [
					  { required: true, message: '请熟人门店名称', trigger: ['blur', 'change'] }
					],
					area_id: [
					  { required: true, message: '请熟人门店名称', trigger: ['blur', 'change'] }
					],
				},
				province:"",
				city:"",
				country:"",
				selectedOptions: [],
				options: regionData,
				mapVisible: false,
				mapPosition: null
			}
		},
		mounted() {
			
		},
		methods:{
			reset() {
			  this.form = {
			   name:'',
			   username:'',
			   wx_code:'',
			   mobile:'',
			   address:'',
			   sort:100,
			   status:1,
			   avatar:'',
			   url:'',
			   area_id:'',
			   province:"",
			   city:"",
			   country:"",
			   coordinate:'',
			  }
			  this.resetForm('form')
			},
			handlelist(id){
				this.$router.push({
				  path:"/store_list",
				  query: {
					  id:id
				  }
				})
			},
			handleChange() {
				this.province= CodeToText[this.selectedOptions[0]]
				this.city= CodeToText[this.selectedOptions[1]]
				this.country= CodeToText[this.selectedOptions[2]]
				this.form.province = CodeToText[this.selectedOptions[0]]
				this.form.city = CodeToText[this.selectedOptions[1]]
				this.form.country = CodeToText[this.selectedOptions[2]]
				this.form.area_id= this.selectedOptions[2]
			},
			handleEdit(row) {
				this.reset()
				this.open = true
				this.title = '编辑'
				this.form = JSON.parse(JSON.stringify(row))
				this.form.coordinate = this.form.latitude+','+this.form.longitude
				this.selectedOptions = []
				if(this.form.area_ids){
					this.province = this.form.province
					this.city = this.form.city
					this.country = this.form.country
					this.selectedOptions.push(
						TextToCode[this.province].code,
						TextToCode[this.province][this.city].code,
						TextToCode[this.province][this.city][this.country].code
					);
				}
			},
			setMap(data) {
			  this.mapPosition = data.position
			  this.form.coordinate = data.position.join(',')
			  this.form.address = data.address
			  this.mapVisible = false
			},
			uploadSuccess(e){
			   if(e.status){
				 this.form.avatar = e.data.id
				 this.form.url = e.data.url
			   }
			},
		}
	}
</script>

<style>
</style>